module.exports = __webpack_public_path__ + "fonts/icomoon.ded8ac6.woff";